export const homeAddToheaderData = [
  {
    id: 1,
    name: "David Maduabuchi",
    img: "/user.svg",
    jobTitle: "Software Developer",
    skill: "Reactjs, VueJs, AngularJs, HTML",
  },
  {
    id: 2,
    name: "Nnaekpe Nnaemeka",
    img: "/user.svg",
    jobTitle: "Game Developer",
    skill: "Unity, C++, Maya, Blender, HTML",
  },
  {
    id: 3,
    name: "Ezendidika Sandra",
    img: "/user.svg",
    jobTitle: "Research Scientist",
    skill: "Biology Research Scientist at the University of Nigeria, Nsukka",
  },
];

export const BusinessServicesData = [
  {
    title: "Hire on LinkedIn",
    description: "Find, attract and recruit talent",
    link: "",
  },
  {
    title: "Sell with LinkedIn",
    description: "Unlock sales opportunities",
    link: "",
  },
  {
    title: "Post a job for free",
    description: "Get qualified applicants quickly",
    link: "",
  },
  {
    title: "Advertise on LinkedIn",
    description: "Acquire customers and grow your business",
    link: "",
  },
  {
    title: "Learn with LinkedIn",
    description: "Courses to develop your employees",
    link: "",
  },
  {
    title: "Admin Center",
    description: "Manage billing and account details",
    link: "",
  },
];
export const PrivacyData = [
  {
    title: "Privacy Policy",
    link: "",
  },
  {
    title: "User Agreement",
    link: "",
  },
  {
    title: "Pages terms",
    link: "",
  },
  {
    title: "Cookie Policy",
    link: "",
  },
  {
    title: "Copyright Policy",
    link: "",
  },
];

export const sectionsData = [
  {
    header: "Explore collaborative articles",
    description:
      "We're unlocking community knowledge in a new way. Experts add insights directly into each article, started with the help of AI.",
    buttonHeader: "",
    coloredBackground: "header",
    buttons: [
      { buttonName: "Marketing", color: "#000" },
      { buttonName: "Public Administration", color: "#000" },
      { buttonName: "Healthcare", color: "#000" },
      { buttonName: "Engineering", color: "#000" },
      { buttonName: "IT Services", color: "#000" },
      { buttonName: "Sustainability", color: "#000" },
      { buttonName: "Business Administration", color: "#000" },
      { buttonName: "Telecommunications", color: "#000" },
      { buttonName: "HR Management", color: "#000" },
      { buttonName: "Show all", color: "#0a66c2", id: "colored-one" },
    ],
  },
  {
    header: "Find the right job or internship for you",
    description: "",
    buttonHeader: "Suggested Searches",
    buttons: [
      { buttonName: "Engineering", color: "" },
      { buttonName: "Business Development", color: "" },
      { buttonName: "Finance", color: "" },
      { buttonName: "Administrative Assistant", color: "" },
      { buttonName: "Retail Associate", color: "" },
      { buttonName: "Customer Service", color: "" },
      { buttonName: "Operations", color: "" },
      { buttonName: "Information Technology", color: "" },
      { buttonName: "Marketing", color: "" },
      { buttonName: "Human Resources", color: "" },
      { buttonName: "HealthCare Service", color: "" },
      { buttonName: "Sales", color: "" },
      { buttonName: "Program and Project Management", color: "" },
      { buttonName: "Acounting", color: "" },
      { buttonName: "Arts and Design", color: "" },
      { buttonName: "Community and Social Services", color: "" },
      { buttonName: "Consulting", color: "" },
      { buttonName: "Education", color: "" },
      { buttonName: "Entrepreneurship", color: "" },
      { buttonName: "Legal", color: "" },
      { buttonName: "Media and Communications", color: "" },
      { buttonName: "Military and Protective Services", color: "" },
      { buttonName: "Product Management", color: "" },
      { buttonName: "Purchasing", color: "" },
      { buttonName: "Quality Assurance", color: "" },
      { buttonName: "Real Estate", color: "" },
      { buttonName: "Research", color: "" },
      { buttonName: "Support", color: "" },
      { buttonName: "Administrative", color: "" },

      // Add more buttons as needed
    ],
  },
  {
    header: "Post your job for millions of people to see",
    description: "",
    coloredBackground: "post",
    buttonName: "Post a job",
    buttons: [
      { buttonName: "Post a job", color: "#0a66c2", id: "colored-one" },
    ],
  },
  {
    header: "Discover the best software tools",
    description:
      "Connect with buyers who have first-hand experience to find the best products for you.",
    buttonHeader: "Suggested Tools",
    buttons: [
      { buttonName: "E-Commerce Platforms", color: "#000" },
      { buttonName: "CRM Software", color: "#000" },
      { buttonName: "Human Resources Management Systems", color: "#000" },
      { buttonName: "Marketing Software", color: "#000" },
      { buttonName: "Sales Intelligence Software", color: "#000" },
      { buttonName: "Project Management Software", color: "#000" },
      { buttonName: "Help Desk Software", color: "#000" },
      { buttonName: "Social Networking Software", color: "#000" },
      { buttonName: "Desktop Publishing Software", color: "#000" },
      { buttonName: "Show all", color: "#0a66c2", id: "colored-one" },
    ],
  },
  {
    header: "Keep your mind sharp with games",
    description:
      "Take a break and reconnect with your network through quick daily games.",
    buttonHeader: "",
    buttons: [
      { buttonName: "Pinpoint", color: "#000" },
      { buttonName: "Queens", color: "#000" },
      { buttonName: "Crossclimb", color: "#000" },
    ],
  },

  // Add more sections as needed
];

export const OpenToWorkData = {
  header: "Let the right people know you're open to work",
  description:
    "With the Open To Work feature, you can privately tell recruiters or publicly share with the LinkedIn community that you are looking for new job opportunities.",
  image: "open-rhs.png",
};

export const ConversationsData = {
  header: "Conversations today could lead to opportunity tomorrow",
  description:
    "Sending messages to people you know is a great way to strengthen relationships as you take the next step in your career.",
  image: "convo.rhs.png",
};

export const upToDateData = {
  header: "Stay up to date on your industry",
  description:
    "From live videos, to stories, to newsletters and more, LinkedIn is full of ways to stay up to date on the latest discussions in your industry.",
  image: "upToDate.png",
};

export const LoginSkills = [
  {
    skill: "Business Analysis and Administration",
    link: "",
    noOfCourses: "1450+ Courses",
  },
  {
    skill: "Business Software and Tools",
    link: "",
    noOfCourses: "2400+ Courses",
  },
  {
    skill: "Career Development",
    link: "",
    noOfCourses: "590+ Courses",
  },
  {
    skill: "Customer Service",
    link: "",
    noOfCourses: "220+ Courses",
  },
  {
    skill: "Diversity, Equity and Inclusion (DE)",
    link: "",
    noOfCourses: "300+ Courses",
  },
  {
    skill: "Finance and Accounting",
    link: "",
    noOfCourses: "310+ Courses",
  },
  {
    skill: "Human Resources",
    link: "",
    noOfCourses: "510+ Courses",
  },
  {
    skill: "Leadership and Management",
    link: "",
    noOfCourses: "1830+ Courses",
  },
  {
    skill: "Project Management",
    link: "",
    noOfCourses: "520+ Courses",
  },
  {
    skill: "Sales",
    link: "",
    noOfCourses: "290+ Courses",
  },
  {
    skill: "Small Business and Entrepreneurship",
    link: "",
    noOfCourses: "340+ Courses",
  },
  {
    skill: "Sales",
    link: "",
    noOfCourses: "290+ Courses",
  },
  {
    skill: "Training and Education",
    link: "",
    noOfCourses: "310+ Courses",
  },
  {
    skill: "Smal Business and Entrepreneurship",
    link: "",
    noOfCourses: "290+ Courses",
  },
  {
    skill: "AEC",
    link: "",
    noOfCourses: "290+ Courses",
  },
  {
    skill: "Animation and Illustrastion",
    link: "",
    noOfCourses: "290+ Courses",
  },
  {
    skill: "Graphic Design",
    link: "",
    noOfCourses: "290+ Courses",
  },
  {
    skill: "Motion Graphic and VFX",
    link: "",
    noOfCourses: "290+ Courses",
  },
  {
    skill: "Photography",
    link: "",
    noOfCourses: "290+ Courses",
  },
  {
    skill: "Product and Manufacturing ",
    link: "",
    noOfCourses: "290+ Courses",
  },
  {
    skill: "User Experience",
    link: "",
    noOfCourses: "290+ Courses",
  },
  {
    skill: "Video",
    link: "",
    noOfCourses: "290+ Courses",
  },
  {
    skill: "Visualization and Real time",
    link: "",
    noOfCourses: "290+ Courses",
  },
  {
    skill: "Web Design",
    link: "",
    noOfCourses: "290+ Courses",
  },
  {
    skill: "Artificial Intelligence",
    link: "",
    noOfCourses: "290+ Courses",
  },
  {
    skill: "Cloud Computing",
    link: "",
    noOfCourses: "290+ Courses",
  },
  {
    skill: "Data Science",
    link: "",
    noOfCourses: "290+ Courses",
  },
  {
    skill: "Database Management",
    link: "",
    noOfCourses: "480+ Courses",
  },
  {
    skill: "DevOps",
    link: "",
    noOfCourses: "330+ Courses",
  },
  {
    skill: "Hardware",
    link: "",
    noOfCourses: "330+ Courses",
  },
  {
    skill: "IT Help Desk",
    link: "",
    noOfCourses: "80+ Courses",
  },
  {
    skill: "Mobile Development",
    link: "",
    noOfCourses: "360+ Courses",
  },
  {
    skill: "Network and System Administration",
    link: "",
    noOfCourses: "1,520+ Courses",
  },
  {
    skill: "Software Development",
    link: "",
    noOfCourses: "2720+ Courses",
  },
  {
    skill: "Web Development",
    link: "",
    noOfCourses: "1750+ Courses",
  },
];

// data.js
export const footerData = {
  sections: [
    {
      title: "General",
      links: [
        { text: "Signup", url: "#" },
        { text: "Help Center", url: "#" },
        { text: "About ", url: "#" },
        { text: "Press", url: "#" },
        { text: "Blog", url: "#" },
        { text: "Caereers", url: "#" },
        { text: "Developers", url: "#" },
      ],
    },
    {
      title: "Browse LinkedIn",
      links: [
        { text: "Learning", url: "#" },
        { text: " Jobs", url: "#" },
        { text: "Games", url: "#" },
        { text: "Salary   ", url: "#" },
        { text: "Mobile", url: "#" },
        { text: "Services", url: "#" },
        { text: "Products", url: "#" },
        { text: "Top Companies Hub", url: "#" },
      ],
    },
    {
      title: "Business Solutions",
      links: [
        { text: "Talent", url: "#" },
        { text: "Marketing", url: "#" },
        { text: "Sales", url: "#" },
        { text: "Learning", url: "#" },
      ],
    },
    {
      title: "Directories",
      links: [
        { text: "Members", url: "#" },
        { text: "Jobs", url: "#" },
        { text: "Companies", url: "#" },
        { text: "Featured", url: "#" },
        { text: "Learning", url: "#" },
        { text: "Posts", url: "#" },
        { text: "Articles", url: "#" },
        { text: "Schools", url: "#" },
        { text: "News", url: "#" },
        { text: "News Letters", url: "#" },
        { text: "Services", url: "#" },
        { text: "Products", url: "#" },
        { text: "Advice", url: "#" },
        { text: "People Search", url: "#" },
      ],
    },
  ],
};

export const loginBottom = [
  {
    title: "About",
    url: "",
  },
  {
    title: "Accessibility",
    url: "",
  },
  {
    title: "User Agreement",
    url: "",
  },
  {
    title: "Privacy Policy",
    url: "",
  },
  {
    title: "Cookie Policy",
    url: "",
  },
  {
    title: "Copyright Policy",
    url: "",
  },
  {
    title: "Brand Policy",
    url: "",
  },
  {
    title: "Community Guidelines",
    url: "",
  },
];
